// src/plugins/vuetify.js

import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import colors from "vuetify/lib/util/colors";
import soonIcon from "@/customIcons/soonIcon.vue";
import menuIcon from "@/customIcons/menuIcon.vue";
import errorIcon from "@/customIcons/errorIcon.vue";
import inboundIcon from "@/customIcons/inboundIcon.vue";
import orderIcon from "@/customIcons/orderIcon.vue";
import quoteIcon from "@/customIcons/quoteIcon.vue";
import returnIcon from "@/customIcons/returnIcon.vue";
import supportIcon from "@/customIcons/supportIcon.vue";
import westoreColoredIcon from "@/customIcons/westoreColoredIcon.vue";
import deliveredIcon from "@/customIcons/deliveredIcon.vue";
import tobeDelivered from "@/customIcons/tobeDelivered.vue";
import dateIcon from "@/customIcons/dateIcon.vue";
import stockIcon from "@/customIcons/stockIcon.vue";
import lineIcon from "@/customIcons/lineIcon.vue";
import importIcon from "@/customIcons/importIcon.vue";
import exportIcon from "@/customIcons/exportIcon.vue";
import downloadIcon from "@/customIcons/downloadIcon.vue";
import whitedownloadIcon from "@/customIcons/white-downloadIcon.vue";
import closeIcon from "@/customIcons/closeIcon.vue";
import questionMarkIcon from "@/customIcons/questionMark.vue";
import exclamationIcon from "@/customIcons/exclamationIcon.vue";
import checkIcon from "@/customIcons/checkIcon.vue";
import chatIconActive from "@/customIcons/chatIconActive.vue";
import chatIconDisabled from "@/customIcons/chatIconDisabled.vue";
import chatIcon from "@/customIcons/chatIcon.vue";
import ordersDeliverd from "@/customIcons/ordersDeliverd.vue";
import codDarkIcon from "@/customIcons/codDarkIcon.vue";
import codIcon from "@/customIcons/codIcon.vue";
import rightArrow from "@/customIcons/rightArrow.vue";
import chevronLeft from "@/customIcons/chevronLeft.vue";
import inProgress from "@/customIcons/inProgress.vue";
import dispatchedIcon from "@/customIcons/dispatchedIcon.vue";
import outDeliveryIcon from "@/customIcons/outDeliveryIcon.vue";
import deliverdStatus from "@/customIcons/deliverdStatus.vue";

Vue.use(Vuetify);

const opts = {
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: "#101820",
        primary_light: "#303335",
        primary_1: "#331435",
        secondary: "#e33065",
        success: "#2ad03d",
        info: "#46beea",
        warning: "#f7ac46",
        danger: "#dd173d",
        danger_light: "#CB3243",
        shadow: "#e9e7e7",
        pink_secondary: "#e91e63",
        white: "#fff",
        grey_light: "#C8CED5",
        accent: colors.indigo.darken3,
      },
    },
  },
  icons: {
    values: {
      soon: {
        component: soonIcon,
      },
      menu: {
        component: menuIcon,
      },
      error: {
        component: errorIcon,
      },
      inboundShipment: {
        component: inboundIcon,
      },
      order: {
        component: orderIcon,
      },
      quote: {
        component: quoteIcon,
      },
      return: {
        component: returnIcon,
      },
      support: {
        component: supportIcon,
      },
      coloredLogo: {
        component: westoreColoredIcon,
      },
      delivered: {
        component: deliveredIcon,
      },
      tobeDelivered: {
        component: tobeDelivered,
      },
      date: {
        component: dateIcon,
      },
      stock: {
        component: stockIcon,
      },
      line: {
        component: lineIcon,
      },
      import: {
        component: importIcon,
      },
      export: {
        component: exportIcon,
      },
      download: {
        component: downloadIcon,
      },
      whiteDownload: {
        component: whitedownloadIcon,
      },
      closeIcon: {
        component: closeIcon,
      },
      questionMark: {
        component: questionMarkIcon,
      },
      exclamation: {
        component: exclamationIcon,
      },
      check: {
        component: checkIcon,
      },
      chatActive: {
        component: chatIconActive,
      },
      chatDisabled: {
        component: chatIconDisabled,
      },
      chat: {
        component: chatIcon,
      },
      ordersDeliverd: {
        component: ordersDeliverd,
      },
      codDarkIcon: {
        component: codDarkIcon,
      },
      codIcon: {
        component: codIcon,
      },
      rightArrow: {
        component: rightArrow,
      },
      chevronLeft: {
        component: chevronLeft,
      },
      inProgress: {
        component: inProgress,
      },
      dispatchedIcon: {
        component: dispatchedIcon,
      },
      outDeliveryIcon: {
        component: outDeliveryIcon,
      },
      deliverdStatus: {
        component: deliverdStatus,
      },
    },
  },
};
export default new Vuetify(opts);
